import {GET, POST} from "../util";

const inspectionUrl = "api/seller-payments-inspection";

const url = {
    inspection: {
        list: `${inspectionUrl}/list`,
        details: `${inspectionUrl}/details/:assignmentId/:receivableId`,
    },
};

const sellerPaymentsApi = {
    inspection: {
        list: (params = {}) => {
            return POST(url.inspection.list, params);
        },
        getDetails: (assignmentId, receivableId) => {
            return GET(url.inspection.details.replace(":assignmentId", assignmentId).replace(":receivableId", receivableId));
        },
    }
};

export {
    sellerPaymentsApi
};